var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection2Backlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1358,
    height: 527,
    viewBox: "0 0 1358 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 1126,
    y: 64,
    width: 232,
    height: 232,
    rx: 50,
    fill: "#15803D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 1017,
    y: 325,
    width: 202,
    height: 202,
    rx: 30,
    fill: "#A21CAF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 756,
    y: 325,
    width: 130,
    height: 130,
    rx: 30,
    fill: "#B45309"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 457,
    width: 161,
    height: 161,
    rx: 50,
    fill: "#0369A1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    y: 207,
    width: 271,
    height: 271,
    rx: 50,
    fill: "#BE185D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2Backlights);
export default __webpack_public_path__ + "static/media/section2backlights.d10fb11764817029e3ff8c38df6f9f34.svg";
export { ForwardRef as ReactComponent };